<kendo-dialog title="{{header}}" *ngIf="dialogOpened" (close)="close('dialog')" [minWidth]="300" [width]="500">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <p>{{message}}</p>
  <kendo-dialog-actions *ngIf="isInfo==true" class="cc-btn-panel">
    <button class="btn btn-primary" (click)="emitSubmit('yes')" primary="true">{{actionYesLabel}}</button>
  </kendo-dialog-actions>

  <kendo-dialog-actions *ngIf="isInfo==false" class="cc-btn-panel">
    <button class="btn btn-secondary" (click)="emitCancel('no')">{{actionNoLabel}}</button>
    <button class="btn btn-primary" (click)="emitSubmit('yes')" primary="true">{{actionYesLabel}}</button>
  </kendo-dialog-actions>
</kendo-dialog>
